import { render, staticRenderFns } from "./RegistrationRequestBuyerInfo.vue?vue&type=template&id=68fb35a6"
import script from "./RegistrationRequestBuyerInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestBuyerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports